<template>
  <div class="upload-files">
    <el-upload
      v-if="!imageUrl"
      v-loading="loading"
      ref="upload"
      action=""
      class="avatar-uploader"
      :show-file-list="false"
      :http-request="handleChange"
      :before-upload="beforeAvatarUpload"
      :limit="1"
    >
      <div class="upload-btn" v-loading="loading">
        <i class="el-icon-plus"></i>
      </div>
    </el-upload>
    <div class="upload-files-box" v-else>
      <el-image
        :src="imageUrl"
        element-loading-text="拼命解析中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
        style="width: 100%; height: 100%"
        fit="cover"
        :preview-src-list="[imageUrl]"
      ></el-image>
      <span class="delete-icon" @click="deleteImage()"
        ><i class="el-icon-circle-close"></i
      ></span>
    </div>
  </div>
</template>

<script>
import { uploadFile } from "@/views/commonApi";

export default {
  name: "UploadFiles",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: String,
      default: "",
    },

    uploadTxt: {
      type: String,
      default: "上传图片",
    },
    maxSize: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      loading: false,
      imageUrl: "",
      dialogVisible: false,
    };
  },
  watch: {
    value: function (newVal, oldVal) {
      // thi/s.$nextTick(() => {
      this.setInitValue(newVal);
      // });
    },
  },
  created: function () {
    // // console.log("创建 ：", this.value);
    // this.setInitValue(this.value);
  },
  methods: {
    deleteImage() {
      this.imageUrl = "";
      this.$emit("change", "");
    },
    setInitValue(value) {
      if (!value) {
        this.value = "";
        this.imageUrl = "";
        return;
      }
      this.getShortImageToken(value);
      // this.$emit("change", this.value);
    },
    // 图片上传之前的
    beforeAvatarUpload(file) {
      // console.log("file", file);
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < this.maxSize;
      if (!isJPG) {
        this.$message.error("上传图片只能是5MB以内JPG格式!");
      }
      if (!isLt5M) {
        this.$message.error(`上传图片大小不能超过 ${this.maxSize}MB!`);
      }
      return isJPG && isLt5M;
    },
    handleChange(file, fileList) {
      this.uploadFiles(file);
    },
    uploadFiles(file) {
      // console.log("file", file);
      let files = file.file;
      let formData = new FormData();
      formData.append("file", files);
      this.loading = true;
      uploadFile(formData)
        // uploadFile(formData)
        .then((res) => {
          this.loading = false;
          this.$refs.upload.clearFiles();
          if (res.code === 200) {
            this.getShortImageToken(res.data.fileId);
            this.$emit("change", res.data.fileId);
          }
        })
        .catch((err) => {
          this.loading = false;

          this.$refs.upload.clearFiles();
          // console.log(err);
        });
    },
    getShortImageToken(fileId) {
      this.imageUrl =
        process.env.VUE_APP_BASE_PATH +
        process.env.VUE_APP_REMOTE_API +
        "/pmy/file/sys-file/download?fileId=" +
        fileId;
    },
  },
};
</script>
<style lang="scss">
.upload-files {
  display: inline-block;
  .el-upload--picture-card {
    border: none;
    width: auto;
    height: auto;
    background: none;
    border-radius: 0;
    line-height: 1;
  }
}
</style>
<style lang="scss" scoped>
.upload-files {
  .el-icon-plus {
    font-size: 0.3rem;
    color: #eaeff5;
  }
  .upload-btn {
    width: 1rem;
    height: 1rem;
    background: #ffffff;
    border-radius: 0.04rem;
    border: 0.01rem solid #eaeff5;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    &:hover {
      border-color: #516ae9;
      color: #516ae9;
    }
  }
  .upload-files-box {
    width: 1rem;
    height: 1rem;
    position: relative;
    .delete-icon {
      position: absolute;
      right: -0.1rem;
      top: -0.2rem;
      font-size: 0.2rem;
      color: red;
      cursor: pointer;
      &:hover {
        color: #b64040;
      }
    }
  }
}
</style>
